import React, { Component, Fragment } from 'react';
import { CustomLoading, Loading } from './LoadingComponent';
import { connect } from 'react-redux';
import { Input, Button, 
         Form, FormGroup, Card, CardBody, ButtonGroup, 
         Modal, ModalBody, ModalHeader, Alert } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { aggregate, sort_by, CustomListSelect, sum_array, toFloat, toFixed, unique_values, previous_date } from './Functions';
import { RenderVirtualTable } from './TableComponent';
import { MultBarPlot, BarPlot, MultLineTsPlot } from './PlotComponent';
import { postRequest } from '../redux/ActionCreators';


// import { Auth } from 'aws-amplify';

const mapStateToProps = state => {
  return {
    user_wm: state.user_wm,
    port_form_builder: state.port_form_builder,
    builder_port_metrics: state.builder_port_metrics,
    builder_port_exposure: state.builder_port_exposure,
    bench_name: state.bench_name,
    builder_params:state.builder_params
  };
};

class PortBuilder extends Component {
  constructor(props){
      super(props);
      this.state = {
        loading_exposure:false,
        loading_metrics:false,
        saving_portfolio:false,
        port_id:'Portafolio',
        show_fx:false,
        load_portfolio:false,
        msg:null,
        msg_save:null
      };
      this.port_form = this.port_form.bind(this);
      this.loadMetrics = this.loadMetrics.bind(this);
      this.savePortfolio = this.savePortfolio.bind(this);
      this.openSaveModal = this.openSaveModal.bind(this); 
      this.addAsset = this.addAsset.bind(this); 
      this.removeAsset = this.removeAsset.bind(this); 
  }


  openSaveModal(){
    if (this.props.builder_params.asset_type=="funds" && this.props.port_form_builder.filter(item=>item.name!='' && item.weight>0).length==0) {
      this.setState({msg:'Seleccionar al menos 1 fondo.'});
    }else if (this.props.builder_params.asset_type!=="funds" && this.props.port_form_builder.filter(item=>item.benchmark!='' && item.weight>0).length==0) {
      this.setState({msg:'Seleccionar al menos 1 índice.'});
    } else {
      this.setState({load_portfolio:true});
    }
  }
  addAsset(){
   console.log("addAsset");
   this.props.changeModel("port_form_builder", [...this.props.port_form_builder].concat({manager:'', name:'', benchmark:"", value:0, weight:0}));
  }
  removeAsset(){
    this.props.changeModel("port_form_builder", [...this.props.port_form_builder].slice(0, -1));
  }

  async savePortfolio(e){
    e.preventDefault();
    const form = e.target;

    if (form.port_name.value==null || form.port_name.value=='') {
      this.setState({msg_save:'Insertar nombre de portafolio.'});
    } else {
      this.setState({saving_portfolio:true});
      try {
        let save_port;
        if (this.props.builder_params.asset_type=="funds"){
          save_port = await postRequest(
            { 
              ref_date:(new Date()).toISOString().slice(0,10),
              port_name:form.port_name.value,
              weights:this.props.port_form_builder.filter(item=>item.name!=='' && item.weight>0).map(item=>{
                return {Asset:item.name, Weight:item.weight, Benchmark:item.benchmark};
              }),
              update_asset_fund_map:this.props.port_form_builder.filter(item=>item.name!='' && item.weight>0 && item.benchmark!='').length>0
            }, 'load_portfolio');
        }else{
          save_port = await postRequest(
            { 
              ref_date:(new Date()).toISOString().slice(0,10),
              port_name:form.port_name.value,
              weights:this.props.port_form_builder.filter(item=>item.benchmark!=='' && item.weight>0).map(item=>{
                return {Asset:item.benchmark, Weight:item.weight};
              }),
            }, 'load_portfolio');
          }
          if (save_port.status === "ok") {
            await this.props.addPort(form.port_name.value);
            await this.props.changeModel("builder_params.msg", `Portafolio ${form.port_name.value} guardado en BD.`);
          }
          this.setState({
            saving_portfolio: false,
            msg_save: save_port.msg,
            load_portfolio: true
          });
      } catch (error) {
        this.setState({
          saving_portfolio:false,
          msg_save: error.message
        });
      }
    }
  }

  async loadMetrics(){
    if (this.props.builder_params.asset_type=="funds" && this.props.port_form_builder.filter(item=>item.name!='' && item.weight>0).length==0) {
      this.setState({msg:'Seleccionar al menos 1 fondo.'});
    } else if (this.props.builder_params.asset_type=="indices" && this.props.port_form_builder.filter(item=>item.benchmark!='' && item.weight>0).length==0) {
      this.setState({msg:'Seleccionar al menos 1 índice.'});
    } else {
      this.setState({loading_exposure:true});
      try {
        let builder_port_exp;
        if (this.props.builder_params.asset_type=="funds"){
          builder_port_exp = await postRequest(
            { 
              port:this.props.port_form_builder.filter(item=>item.name!='' && item.weight>0).map(item=>{
                return {name:item.name, value:toFloat(item['value'])};
              }),
              bench:this.props.bench_name,
              own_only:this.props.user_wm.data?.role==3 ? true : false,
              port_groups:this.props.user_wm.data?.port_groups
            }, 'port_exposure_wm');
        }else{
          builder_port_exp = await postRequest(
            { 
              port:this.props.port_form_builder.filter(item=>item.benchmark!='' && item.weight>0).map(item=>{
                return {name:item.benchmark, value:toFloat(item['value'])};
              }),
              bench:this.props.bench_name
  
            }, 'port_exposure_wm');
        }
        await this.props.changeModel('builder_port_exposure', builder_port_exp);
      } catch (error) {
        console.error('Error getting response:', error);
        this.setState({
          loading_exposure:false,
          msg: error.message
        });
        return;
      }
      try {
        this.setState({
          loading_exposure:false,
          loading_metrics:true
        });
        let builder_port_metrics;
        if (this.props.builder_params.asset_type=="funds"){
          builder_port_metrics = await postRequest(
            {
              ref_curr:this.props.builder_params.ref_curr, 
              port:this.props.port_form_builder.filter(item=>item.name!=='' && item.weight>0).map(item=>{
                return {name:item.name, value:toFloat(item['value'])};
              }),
              bench:this.props.bench_name,
              ini_date:previous_date(this.props.builder_params.range),
              own_only:this.props.user_wm.data?.role==3 ? true : false,
              port_groups:this.props.user_wm.data?.port_groups
              
            }, 'port_metrics_wm');
        } else {
          builder_port_metrics = await postRequest(
            {
              ref_curr:this.props.builder_params.ref_curr, 
              port:this.props.port_form_builder.filter(item=>item.benchmark!=='' && item.weight>0).map(item=>{
                return {name:item.benchmark, value:toFloat(item['value'])};
              }),
              bench:this.props.bench_name,
              ini_date:previous_date(this.props.builder_params.range)
            }, 'port_metrics_wm');
        }
        await this.props.changeModel('builder_port_metrics', builder_port_metrics);
        this.setState({loading_metrics:false});
      } catch (error) {
        console.error('Error getting response:', error);
        this.setState({
          loading_metrics:false,
          msg: error.message
        });
      }
    }
  }

  async handleInputChange(value, idx, name) {
    // interpret empty string as 0 if the field is "value"
    const parsedValue = name === 'value' ? (value === "" ? 0 : toFloat(value)) : value;
  
    let port_form_temp = [...this.props.port_form_builder];
    port_form_temp[idx] = {
      ...port_form_temp[idx],
      [name]: parsedValue,
    };
  
    if (name === 'value') {
      const total = sum_array(
        port_form_temp
          .filter(x => toFloat(x.value) > 0)
          .map(x => toFloat(x.value))
      );
  
      port_form_temp = port_form_temp.map(item => ({
        ...item,
        weight: total > 0 ? toFloat(item.value || 0) / total : 0,
      }));
    }
  
    await this.props.changeModel('port_form_builder', port_form_temp);
  }
  
  port_form(idx, funds_ind) {
    if (this.props.user_wm.data?.assets){
      const benchmarkCol = funds_ind ? "col-3" : "col-5";  // stretch if no funds
      const valueCol = funds_ind ? "col-2" : "col-3";
      return(
         <div className="row justify-content-center" key={idx}>
            <div className="col-12">
              <FormGroup>
                <div className='row justify-content-center'>
                  {funds_ind ?
                  <>
                    <div className="col-2">
                      <CustomListSelect
                        options={unique_values(this.props.user_wm.data.assets.filter(x=>x.Manager!=="").sort((a, b) => a.Manager.localeCompare(b.Manager)), 'Manager').map(x=>{
                          return {value:x, label:x};
                        })}
                        isClearable={true}
                        value={{value:this.props.port_form_builder[idx]['manager'], label:this.props.port_form_builder[idx]['manager']}}
                        onChange={(e) => this.handleInputChange(e ? e.value : '', idx, "manager")}
                        itemSize={40}
                        className="basic-single"
                        placeholder="manager"
                        fontSize={12}
                      />
                    </div>
                    <div className="col-3">
                    {this.props.port_form_builder[idx] && (
                      <CustomListSelect
                        options={this.props.port_form_builder[idx].manager !== ''? 
                            this.props.user_wm.data.assets.filter(
                              x => x.Manager === this.props.port_form_builder[idx].manager
                            ).map(x => (
                              {value:x.Asset, label:x.Isin!=="" ? `${x.Asset} | ${x.Isin}` : (x.Ticker!=="" && x.Ticker!==x.Asset) ? `${x.Asset} | ${x.Ticker}` : x.Asset}
                            ))
                          : []
                        }
                        isClearable={true}
                        value={{value:this.props.port_form_builder[idx].name || '', label:this.props.port_form_builder[idx].name || ''}} 
                        onChange={(e) => this.handleInputChange(e ? e.value : '', idx, "name")}
                        itemSize={45}
                        className="basic-single"
                        placeholder="fondo"
                        fontSize={12}
                      />
                    )}
                    </div>
                  </>
                  :null
                  }
                  <div className={benchmarkCol}>
                    <CustomListSelect
                      options={this.props.user_wm.data.assets.map(x=>{
                        return {value:x.Asset, label:x.Ticker!=="" ? `${x.Asset} | ${x.Ticker}` : x.Isin!=="" ? `${x.Asset} | ${x.Isin}` : x.Asset};
                      })}
                      isClearable={true}
                      value={{value:this.props.port_form_builder[idx]['benchmark'], label:this.props.port_form_builder[idx]['benchmark']}}
                      onChange={(e) => this.handleInputChange(e ? e.value : '', idx, "benchmark")}
                      itemSize={45}
                      className="basic-single"
                      placeholder="benchmark"
                      fontSize={12}
                    />
                  </div>
                  <div className={valueCol}>
                    <Input 
                      size="sm"
                      type="text" 
                      name="value" 
                      value={this.props.port_form_builder[idx]['value'] || ""} 
                      onChange={(e)=>{
                        const val = e.target.value;  // extract the primitive value right away
                        this.handleInputChange(val, idx, "value");
                      }}>
                    </Input>
                  </div>
                  <div className={valueCol}>
                    <p><small>{this.props.port_form_builder.filter(x=>toFloat(x.value)>0).length==0 ? '0.00%': `${toFixed(100*this.props.port_form_builder[idx]['value']/sum_array(this.props.port_form_builder.filter(x=>toFloat(x.value)>0).map(x=>toFloat(x.value))))}%`}</small></p>
                  </div>
                </div>  
              </FormGroup>
            </div>
          </div>
        );
     }else {return null;}
  };

  render() {
      if(this.props.user_wm.isLogging){
        return(
          <div className='container'>
            <div className="row justify-content-center">
                <Loading />
            </div>
          </div>
        );
      } else {
        let port_assetclass_exp = this.props.builder_port_exposure==null ? null  
          : this.props.builder_port_exposure.names.length==1 ? 
          aggregate(this.props.builder_port_exposure.w_ac, ['AssetClass'], ['Portafolio']).sort(sort_by('value'))
          : aggregate(this.props.builder_port_exposure.w_ac, ['AssetClass'], ['Portafolio', 'Benchmark']).sort(sort_by('value'));

        let port_curr_exp = this.props.builder_port_exposure==null ? null
                            : this.props.builder_port_exposure.names.length==1 ?
                            aggregate(this.props.builder_port_exposure.w_ac, ['Currency'], ['Portafolio']).sort(sort_by('value'))
                            : aggregate(this.props.builder_port_exposure.w_ac, ['Currency'], ['Portafolio', 'Benchmark']).sort(sort_by('value'));

        const real_rets = this.props.builder_port_metrics==null ? null
                          : this.props.builder_port_metrics.real_rets;

        const rets_summ = this.props.builder_port_metrics==null ? null
                          : this.props.builder_port_exposure.names.length==1 ? 
                          this.props.builder_port_metrics.rets_summ.map(({Métrica, Portafolio}) => ({Métrica, Portafolio})) :
                          this.props.builder_port_metrics.rets_summ.map(({Métrica, Portafolio, Benchmark}) => ({Métrica, Portafolio, Benchmark}));
        const series = this.props.builder_port_metrics==null ? null : this.props.builder_port_metrics.series;
        return (
          <div className="container">
            <div className="row mt-5 justify-content-center">
              <div className="col-lg-8">
                <h4>Construcción de Portafolio</h4>
              </div>  
            </div>
            <div className="row m-4 justify-content-center">
              <div className='col-3'>
                <ButtonGroup size='sm'>
                  <Button
                    color="dark"
                    outline
                    onClick={() => this.props.changeModel("builder_params.asset_type", 'indices')}
                    active={this.props.builder_params.asset_type=='indices'}
                  >
                    Índices
                  </Button>
                  <Button
                    color="dark"
                    outline
                    onClick={() => this.props.changeModel("builder_params.asset_type", 'funds')}
                    active={this.props.builder_params.asset_type=='funds'}
                  >
                    Fondos/ETFs
                  </Button>
                </ButtonGroup>
              </div>
            </div>
            <div className="row m-0 justify-content-center">
              <div className="col-4 m-0">
                <Alert
                  color='secondary'
                  isOpen={this.props.builder_params.msg!==null} 
                  toggle={()=>this.props.changeModel("builder_params.msg", null)}
                  fade={false}
                  >
                    {this.props.builder_params.msg}
                </Alert>
              </div>
            </div>
            <div className="row mt-5 justify-content-center">
              <div className={this.props.builder_params.asset_type=="funds" ? "col-8" : "col-5"}>
                <div className="row justify-content-center">
                  {this.props.builder_params.asset_type=="funds" ?
                  <>
                    <div className="col-2">
                      <p><b>Manager</b></p>
                    </div>
                    <div className="col-3">
                      <p><b>Fondo</b></p>
                    </div>
                  </>
                  :null
                  }
                  <div className={this.props.builder_params.asset_type=="funds" ? "col-3" : "col-5"}>
                    <p><b>Benchmark</b></p>
                  </div>
                  <div className={this.props.builder_params.asset_type=="funds" ? "col-2" : "col-3"}>
                    <p><b>Monto ($)</b></p>
                  </div>
                  <div className={this.props.builder_params.asset_type=="funds" ? "col-2" : "col-3"}>
                    <p><b>Peso (%)</b></p>
                  </div>
                </div>
              </div>  
            </div>
            <div className="row justify-content-center">
              <div className={this.props.builder_params.asset_type=="funds" ? "col-8" : "col-5"}>
                <Card className="card-inv">
                  <CardBody>
                    {[...Array(this.props.port_form_builder.length).keys()].map(k=>{
                      return this.port_form(k, this.props.builder_params.asset_type=="funds");
                    })}
                  </CardBody>
                </Card>
              </div>  
            </div>
            <div className="row justify-content-center">
              <div className='col-auto'>
                <Button 
                  className="link-btn"
                  onClick={this.addAsset}
                >
                  <small>agregar activo+</small>
                </Button>
              </div>
              <div className='col-auto'>
                <Button 
                  className="link-btn"
                  onClick={this.removeAsset}
                >
                  <small>remover activo-</small>
                </Button>
              </div>
            </div>
            { this.state.loading_exposure
              ? <div className="row m-3 justify-content-center align-items-center">
                  <CustomLoading msg="calculando exposición" icon="fa-server"/>
                </div>
              : this.state.loading_metrics 
              ? <div className="row m-3 justify-content-center align-items-center">
                  <CustomLoading msg="calculando métricas" icon="fa-calculator"/>
                </div>
              : <>
                  <div className="row m-5 justify-content-center align-items-center">
                    <div className='col-auto'>
                      <Button 
                        className="btn-corp"
                        onClick={this.loadMetrics}
                      >
                        Actualizar Métricas
                      </Button>
                    </div>
                    <div className='col-auto'>
                      <Button 
                        className="btn-corp"
                        onClick={this.openSaveModal}
                      >
                        Guardar Portafolio
                      </Button>
                    </div>
                  </div>
                  {this.state.msg!=='' && this.state.msg!==null ?
                    <div className="row mt-4 justify-content-center">
                      <div className="col-6 m-3">
                        <Alert
                          color={this.state.msg.includes('Error') ? 'danger':'secondary'}
                          isOpen={this.state.msg!=='' && this.state.msg!==null} 
                          toggle={()=>this.setState({msg:null})}
                          fade={false}>
                            {this.state.msg}
                        </Alert>
                      </div>
                    </div>
                    :<></>
                  }
                </>
            }

            <Modal isOpen={this.state.load_portfolio} toggle={()=>this.setState({load_portfolio:!this.state.load_portfolio})}>
              <ModalHeader toggle={()=>this.setState({load_portfolio:!this.state.load_portfolio})}>Guardar Portafolio</ModalHeader>
              <ModalBody>
                <Form onSubmit={this.savePortfolio}>
                  <div className="row m-4 justify-content-center">
                    <div className="col-8 m-1">
                      <Input
                        id='port_name'
                        type='text'
                        placeholder="Nombre..."
                      >
                      </Input>
                    </div>
                  </div>
                  <div className="row m-1 justify-content-center">
                    {this.state.saving_portfolio ?
                      <div className='col-auto'>
                        <CustomLoading msg="guardando" icon="fa-database"/>
                      </div>
                    : 
                      <div className="col-auto m-1">
                        <Button 
                          type='submit'
                          className="btn-corp">
                            Guardar
                        </Button>
                      </div>
                    }
                  </div>
                  <div className="row mt-4 justify-content-center">
                    <div className="col m-3">
                      <Alert
                        color='secondary'
                        isOpen={this.state.msg_save!=='' && this.state.msg_save!==null} 
                        toggle={()=>this.setState({msg_save:null})}
                        fade={false}
                      >
                        {this.state.msg_save}
                      </Alert>
                    </div>
                  </div>
                </Form>
              </ModalBody>  
            </Modal>
            <div className="row m-3 justify-content-center align-items-center">
              <div className='col-12 col-lg-3 p-2'>
                <CustomListSelect
                  options={this.props.user_wm.data?.ports_list}
                  isClearable={true}
                  defaultValue={{value:this.props.bench_name, label:this.props.bench_name}}
                  onChange={(e)=>this.props.changeModel("bench_name", e==null ? null : e.value)}
                  itemSize={50}
                  className="basic-single"
                  placeholder="seleccionar benchmark"
                />
              </div>
              <div className='col-6 col-lg-1 p-2'>
                <Input type="select" 
                  value={this.props.builder_params.ref_curr} 
                  onChange={(e)=>this.props.changeModel('builder_params.ref_curr',e.target.value)}>
                  {['USD','MXN','COP','PEN', 'CLP', "UYU"].map((x,i)=>{
                    return (<option key={i}>{x}</option>);
                  })}
                </Input>
              </div>
              <div className='col-6 col-lg-2 p-2'>
                <CustomListSelect
                  options={["YTD", "1Y", "3Y", "5Y", "10Y"].map(x=>{
                    return {value:x, label:x};
                  })}
                  isClearable={true}
                  value={{value:this.props.builder_params.range, label:this.props.builder_params.range}}
                  onChange={(e)=>this.props.changeModel("builder_params.range", e==null ? null : e.value)}
                  itemSize={30}
                  className="basic-single"
                  placeholder="periodo..."
                />
              </div>
            </div>
            {series!=null 
            ? <>
              <div className="row m-5 justify-content-center">
                <div className='col' id="risk">
                  <h5><b>Riesgo - Retorno</b></h5>
                  <a className='linkcol' href='#rr'>retornos-realizados&darr;</a>
                  <a className='linkcol' href='#exp'>{"       "}exposición&darr;</a>
                </div>
              </div>
              <div className="row m-4 justify-content-center align-items-start">
                <div className='col-lg-6'>
                  <div className="row justify-content-center align-items-center">
                    <div className='col-auto'>
                      <RenderVirtualTable 
                        data={rets_summ} 
                        to_perc={[false, true, true]}
                        to_perc_row={[true, true, true, true, false, true, false, false, false]}
                        cell_width={['200px', "100px", '100px']}
                        item_size={30}
                        fontsize={13}
                        style="black"
                        />
                    </div>
                  </div>
                </div>
                <div className='col-lg-6'>
                  <MultLineTsPlot 
                    data={series}
                    width={500}
                    xkey='Date'
                    ykeys={this.props.builder_port_metrics.names}
                    xtype='category'
                    ytype='number'
                    colors = {['#000000', "#1215E3"]}
                    percTooltip={false}
                    legend={true ? this.props.builder_port_metrics.names.length > 1 : false}
                    ml={50}
                  />
                </div>
              </div>
              </>
            : <></>
            }
            
            {real_rets!=null 
            ? 
            <>
              <div className="row m-5 justify-content-center">
                <div className='col' id="rr">
                  <h5>Retornos Realizados</h5>
                  <a className='linkcol' href='#risk'>riesgo-retorno&uarr;</a>
                  <a className='linkcol' href='#exp'>{"       "}exposición&darr;</a>
                </div>
              </div>
              <div className="row m-4 justify-content-center align-items-start">
                <div className='col-lg-6'>
                  <div className="row justify-content-center align-items-center">
                    <div className='col-auto'>
                      <RenderVirtualTable 
                        data={real_rets} 
                        to_perc={[false, true, true]}
                        cell_width={["200px", '100px', '100px']}
                        item_size={30}
                        fontsize={13}
                        style="black"
                        />
                    </div>
                  </div>
                </div>
                
                <div className='col-lg-6'>
                  {this.props.builder_port_metrics.names.length>1
                  ? <MultBarPlot 
                      data={real_rets}
                      nameKey='Periodo'
                      vertical={true}
                      angle={0}
                      ytype="category" xtype="number"
                      colors={["#000000", "#1215E3"]}
                      xpercAxis={true}
                      moneyTooltip={false}
                      width={500}
                      height={400}
                      interval={0}
                      barsize={10}
                      fontsize={10}
                    />
                  : <BarPlot 
                      y={real_rets.map(x=>x.Periodo)}
                      x={real_rets.map(x=>x.Portafolio)}
                      layout="vertical"
                      angle={0}
                      ytype="category" xtype="number"
                      color="#000000"
                      xpercAxis={true}
                      moneyTooltip={true}
                      width={500}
                      height={400}
                      interval={0}
                      barsize={10}
                      fontsize={10}
                    />
                  }
                </div>
              </div>
            </>
            : <></>
            }
            {/*Exposición*/}
            {port_assetclass_exp!==null ?
            <>
              <div className="row mt-5 justify-content-center">
                <div className='col' id="exp">
                  <h5><b>Exposición</b></h5>
                  <a className='linkcol' href='#risk'>riesgo-retorno&uarr;</a>
                  <a className='linkcol' href='#rr'>{"       "}retorno-realizados&uarr;</a>
                </div>
              </div>
              <div className="row mt-4 justify-content-center">
                <div className='col-lg-6'>
                  <h6>Clase de Activo</h6>
                    <MultBarPlot 
                      data={port_assetclass_exp}
                      nameKey='AssetClass'
                      vertical={true}
                      angle={0}
                      ytype="category" xtype="number"
                      colors={["#000000", "#1215E3"]}
                      xpercAxis={true}
                      moneyTooltip={false}
                      width={600}
                      interval={0}
                      height={400}
                      barsize={20}
                      fontsize={12}
                    />
                </div>
                <div className='col-lg-6'>
                  <h6>Moneda</h6>
                  <MultBarPlot 
                    data={port_curr_exp}
                    nameKey='Currency'
                    vertical={true}
                    angle={0}
                    ytype="category" xtype="number"
                    colors={["#000000", "#1215E3"]}
                    xpercAxis={true}
                    moneyTooltip={false}
                    width={500}
                    interval={0}
                    height={400}
                    barsize={20}
                    fontsize={12}
                  />
  
                </div>
              </div>
            </>:<></>
            }
          </div>
        );
      }
    }
}
//export default Port;
export default withRouter(connect(mapStateToProps)(PortBuilder));